module.exports = __webpack_public_path__ + "img/ic_socialprofiles.6aaa3e86.svg";